export interface IManualTriggerDto {
    tripId?: string;
    tripCode?: string;
    checkpointIndex: number;
    inDate: string;
    outDate?: string;
}
